<syn-avatar
    [matIco]="synIco"
    matIco="help"
    [size]="size"
    [iconSize]="22"
    [tooltip]="tooltip ? title : ''"
    [link]="clickable ? link : undefined"
    [text]="text"
    [backgroundColor]="backgroundColor"
    [maxWidth]="maxWidth"
    [wrap]="wrap"
    [iconColor]="iconColor"
    [caption]="caption"
></syn-avatar>
